import React from 'react'

const WhyChooseUs = () => {
       const features = [
    {
      icon: '✅',
      title: '100% Practical-Based Learning',
      description: 'Hands-on experience with real-world projects and industry scenarios',
    },
    {
      icon: '👨‍💻',
      title: 'Experienced Mentors & Developers',
      description: 'Learn from industry experts with years of professional experience',
    },
    {
      icon: '🎓',
      title: 'Industry-Grade Projects & Internships',
      description: 'Work on actual business projects and gain valuable industry exposure',
    },
    {
      icon: '🤖',
      title: 'Customizable Robotics and IoT Labs',
      description: 'Fully equipped labs tailored to your institution’s specific needs',
    },
  ];
  return (
      <section className="py-5 bg-light">
  <div className="container text-center mb-5">
    <h2 className="fw-bold display-5">Why Choose Us?</h2>
    <p className="fs-5 text-muted">
      We combine expertise, innovation, and practical learning to deliver exceptional results
    </p>
  </div>

  <div className="container">
    <div className="row g-4">
      {features.map((feature, index) => (
        <div className="col-md-6" key={index}>
          <div className="d-flex align-items-start bg-white p-4 rounded shadow-sm h-100">
            <div className="me-4 fs-2">{feature.icon}</div>
            <div>
              <h5 className="mb-2 fs-4">{feature.title}</h5>
              <p className="text-muted fs-5 mb-0">{feature.description}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
  )
}

export default WhyChooseUs
